import { createAction, props } from '@ngrx/store';
import {
  IPayloadCreazioneUtenza,
  IResponseCreazioneUtenza,
  IResponseGestioneUtenze,
} from '../../interfaces/gestione-utenze';
import { RetrieveUtilityLdv } from '../../interfaces/retrieve-utility-ldv';
import { GenericResponse } from '../../interfaces/generic-response';
import {
  IPayloadDownloadUtilityReportPuntoPoste,
  IResponseListaReteTerze,
} from '../../interfaces/utility-report-punto-poste';
import { IResponseCompensiRete } from '../../interfaces/compensi';
import { ResponseAnagraphicManagement } from '../../interfaces/response-anagraphic-management';
import { IConfigurazioneBoxless } from '../../interfaces/configurazione-boxless';
import {
  PayloadNearlistXls,
  ResponseNearlistUffPostale,
} from '../../interfaces/nearlist';
import { ResponseCercaPerStrutturaRecapito } from '../../interfaces/cerca-per-struttura-recapito';
import {
  IPayloadGo,
  IResponseGo,
  IPayloadRamGo,
  IResponseRamGo,
  IPayloadCdGo,
  IResponseCdGo,
  IPayloadFraz,
  IResponseFraz,
  IResponseRecapito,
} from '../../interfaces/go';
import { PayloadCercaStrutturaRecapito } from '../../interfaces/payload-cerca-struttura-recapito';
import {
  IResponseListaCatalogoMateriale,
  ISaveListaCatalogoMateriale,
} from '../../interfaces/catalogo-materiale';
import { IResponseCluster } from '../../interfaces/cluster';
import {
  IPayloadConfigurazioneApprovvigionamento,
  IResponseConfigurazioneApprovvigionamento,
  IResponseOrdiniApprovvigionamento,
} from '../../interfaces/configurazione-approvvigionamento';
import { IResponseRegoleOrdine } from '../../interfaces/regole-ordine';
import { PayloadOrderHistory } from '../../interfaces/payload-order-history';
import { ResponseOrderHistory } from '../../interfaces/response-order-history';
import { ResponseCreazioneOrdine } from '../../interfaces/response-creazione-ordine';
import { IUtilitiesState } from './utilities';
import { IPinRecoveryPayload, IResponsePinRecovery } from '../../interfaces/pin-recovery';

export const RETRIEVE_UTILITY_LDV = createAction(
  '[UTILITY] - retrieve LDV',
  props<{ payload: string }>()
);

export const RETRIEVE_UTILITY_LDV_SUCCESS = createAction(
  '[UTILITY] - retrieve LDV success',
  props<{ responseUtilityLdv: RetrieveUtilityLdv }>()
);

export const UPLOAD_DOCUMENT_LDV = createAction(
  '[UTILITY] - upload file document LDV',
  props<{ payload: FormData; idSpedizione: string; state: string }>()
);

export const UPLOAD_DOCUMENT_LDV_SUCCESS = createAction(
  '[UTILITY] - upload file document LDV success',
  props<{ responseDocumentoLdv: GenericResponse }>()
);

export const DOWNLOAD_LDV_DOC = createAction(
  '[UTILITY] - download LDV doc',
  props<{ payload: string }>()
);

export const RETRIEVE_GESTIONE_UTENZE = createAction(
  '[GESTIONE UTENZE] - retrieve gestione utenze'
);

export const RETRIEVE_GESTIONE_UTENZE_SUCCESS = createAction(
  '[GESTIONE UTENZE] - retrieve gestione utenze success',
  props<{ responseGestioneUtenze: IResponseGestioneUtenze | null }>()
);

export const CREATE_UTENZA = createAction(
  '[GESTIONE UTENZE] - create utenza',
  props<{ payload: IPayloadCreazioneUtenza }>()
);

export const CREATE_UTENZA_SUCCESS = createAction(
  '[GESTIONE UTENZE] - create utenza success',
  props<{ responseCreazioneUtenza: IResponseCreazioneUtenza }>()
);

export const RETRIEVE_LISTA_RETE_TERZE = createAction(
  '[REPORT PUNTO POSTE] - retrieve lista rete terze'
);

export const RETRIEVE_LISTA_RETE_TERZE_SUCCESS = createAction(
  '[REPORT PUNTO POSTE] - retrieve lista rete terze success',
  props<{ responseListaReteTerze: IResponseListaReteTerze }>()
);

export const DOWNLOAD_UTILITY_REPORT_PUNTO_POSTE = createAction(
  '[REPORT PUNTO POSTE] - download report punto poste',
  props<{ payload: IPayloadDownloadUtilityReportPuntoPoste }>()
);

export const RETRIEVE_RETE_TERZA_LIST = createAction(
  '[GESTIONE UTENZE] - retrieve rete terza list'
);

export const RETRIEVE_RETE_TERZA_LIST_SUCCESS = createAction(
  '[GESTIONE UTENZE] - retrieve rete terza list success',
  props<{ responseReteTerzaList: ResponseAnagraphicManagement | null }>()
);

export const RETRIEVE_COMPENSI_RETE = createAction(
  '[GESTIONE UTENZE] - retrieve compensi rete',
  props<{ rete: string }>()
);

export const RETRIEVE_COMPENSI_RETE_SUCCESS = createAction(
  '[GESTIONE UTENZE] - retrieve compensi rete success',
  props<{ responseCompensiRete: IResponseCompensiRete | null }>()
);

export const RETRIEVE_COMPENSI_RETE_POST = createAction(
  '[GESTIONE UTENZE] - retrieve compensi rete post',
  props<{ rete: string; file: FormData }>()
);

export const RETRIEVE_COMPENSI_RETE_POST_SUCCESS = createAction(
  '[GESTIONE UTENZE] - retrieve compensi rete success post',
  props<{ responseCompensiRetePost: IResponseCompensiRete | null }>()
);

export const RETRIEVE_CONFIGURAZIONE_BOXLESS = createAction(
  '[CONFIGURAZIONE BOXLESS] - retrieve configurazione boxless'
);

export const RETRIEVE_CONFIGURAZIONE_BOXLESS_SUCCESS = createAction(
  '[CONFIGURAZIONE BOXLESS] - retrieve configurazione boxless success',
  props<{ responseConfigurazioneBoxless: IConfigurazioneBoxless }>()
);

export const RETRIEVE_CONFIGURAZIONE_BOXLESS_POST = createAction(
  '[CONFIGURAZIONE BOXLESS] - retrieve configurazione boxless post',
  props<{ payload: IConfigurazioneBoxless }>()
);

export const RETRIEVE_CONFIGURAZIONE_BOXLESS_POST_SUCCESS = createAction(
  '[CONFIGURAZIONE BOXLESS] - retrieve configurazione boxless post success',
  props<{ responseConfigurazioneBoxlessPost: IConfigurazioneBoxless }>()
);

export const RETRIEVE_NEARLIST_UFF_POSTALE = createAction(
  '[NEARLIST UFFPOSTALE] - retrieve list uffPostale',
  props<{ uffPostale: string }>()
);

export const RETRIEVE_NEARLIST_UFF_POSTALE_SUCCESS = createAction(
  '[NEARLIST UFFPOSTALE] - retrieve list uffPostale success',
  props<{ responseNearlistUffPostale: ResponseNearlistUffPostale }>()
);

export const RETRIEVE_NEARLIST_XLS = createAction(
  '[DOWNLOAD REPORT] - retrieve uffPostale xls',
  props<{ payload: PayloadNearlistXls }>() // in teoria nearlistUffPostale
);
export const SEARCH_LISTA_RECAPITO = createAction(
  '[UTILITY] - cerca lista recapito',
  props<{ payload: PayloadCercaStrutturaRecapito }>()
);

export const SEARCH_LISTA_RECAPITO_SUCCESS = createAction(
  '[UTILITY] - cerca lista recapito success',
  props<{ responseCercaRecapito: ResponseCercaPerStrutturaRecapito | null }>()
);

export const DOWNLOAD_LISTA_RECAPITO = createAction(
  '[UTILITY] - download lista recapito',
  props<{ payload: Partial<ResponseCercaPerStrutturaRecapito> }>()
);

export const RETRIEVE_GO = createAction(
  '[UTILITY] - retrieve go',
  props<{ payload?: IPayloadGo }>()
);

export const RETRIEVE_GO_SUCCESS = createAction(
  '[UTILITY] - retrieve go success',
  props<{ responseGo: IResponseGo }>()
);

export const RETRIEVE_RAM_GO = createAction(
  '[UTILITY] - retrieve ram go',
  props<{ payload?: IPayloadRamGo }>()
);

export const RETRIEVE_RAM_GO_SUCCESS = createAction(
  '[UTILITY] - retrieve ram go success',
  props<{ responseRamGo: IResponseRamGo }>()
);

export const RETRIEVE_CD_GO = createAction(
  '[UTILITY] - retrieve cd go',
  props<{ payload?: IPayloadCdGo }>()
);

export const RETRIEVE_CD_GO_SUCCESS = createAction(
  '[UTILITY] - retrieve ram cd success',
  props<{ responseCdGo: IResponseCdGo }>()
);

export const RETRIEVE_FRAZ = createAction(
  '[UTILITY] - retrieve fraz',
  props<{ payload?: IPayloadFraz }>()
);

export const RETRIEVE_FRAZ_SUCCESS = createAction(
  '[UTILITY] - retrieve fraz success',
  props<{ responseFraz: IResponseFraz }>()
);

export const RETRIEVE_RECAPITO = createAction(
  '[UTILITY] - retrieve recapito',
  props<{ idFraz: string }>()
);

export const RETRIEVE_RECAPITO_SUCCESS = createAction(
  '[UTILITY] - retrieve recapito success',
  props<{ responseRecapito: IResponseRecapito | null }>()
);

export const RETRIEVE_LISTA_CATALOGO_MATERIALE = createAction(
  '[UTILITY] - retrieve lista catalogo materiale'
);

export const RETRIEVE_LISTA_CATALOGO_MATERIALE_SUCCESS = createAction(
  '[UTILITY] - retrieve lista catalogo materiale success',
  props<{
    responseListaCatalogoMateriale: IResponseListaCatalogoMateriale | null;
  }>()
);

export const RETRIEVE_LISTA_CLUSTER = createAction(
  '[UTILITY] - retrieve lista cluster'
);

export const RETRIEVE_CONFIGURAZIONE_APPROVIGIONAMENTO = createAction(
  '[UTILITY] - retrieve configurazione approvvigionamento'
);

export const RETRIEVE_CONFIGURAZIONE_APPROVIGIONAMENTO_SUCCESS = createAction(
  '[UTILITY] - retrieve configurazione approvvigionamento success',
  props<{
    responseConfigurazioneApprovvigionamento: IResponseConfigurazioneApprovvigionamento | null;
  }>()
);

export const RETRIEVE_REGOLE_ORDINE = createAction(
  '[UTILITY] - retrieve regole ordine'
);

export const RETRIEVE_REGOLE_ORDINE_SUCCESS = createAction(
  '[UTILITY] - retrieve regole ordine success',
  props<{ responseRegoleOrdine: IResponseRegoleOrdine | null }>()
);

export const DOWNLOAD_REPORT_ORDER_HISTORY = createAction(
  '[UTILITY] - download report storico ordini',
  props<{ payload: PayloadOrderHistory }>()
);

export const RETRIEVE_ORDER_HISTORY = createAction(
  '[UTILITY] - retrieve storico ordini',
  props<{ payload: PayloadOrderHistory }>()
);

export const RETRIEVE_CREATE_ORDER = createAction(
  '[UTILITY] - retrieve creazione ordine',
  props<{ payload: any }>()
);

export const RETRIEVE_CREATE_ORDER_SUCCESS = createAction(
  '[UTILITY] - retrieve creazione ordine success',
  props<{ responseCreazioneOrdine: ResponseCreazioneOrdine | null }>()
);

export const CHANGE_QUANTITY_CREATE_ORDER = createAction(
  '[UTILITY] - change quantity create order',
  props<{ payload: any }>()
);

export const RETRIEVE_ORDER_HISTORY_SUCCESS = createAction(
  '[UTILITY] - retrieve storico ordini success',
  props<{ responseStoricoOrdini: ResponseOrderHistory | null }>()
);

export const RETRIEVE_LISTA_CLUSTER_SUCCESS = createAction(
  '[UTILITY] - retrieve lista cluster success',
  props<{ responseListaCluster: IResponseCluster | null }>()
);

export const SAVE_LISTA_CATALOGO_MATERIALE = createAction(
  '[UTILITY] - save lista catalogo materiale',
  props<{ payload: ISaveListaCatalogoMateriale }>()
);

export const DOWNLOAD_CATALOGO_MATERIALE = createAction(
  '[UTILITY] - download catalogo materiale'
);

export const SAVE_CONFIGURAZIONE_APPROVIGIONAMENTO = createAction(
  '[UTILITY] - save configurazione approvvigionamento',
  props<{ payload: IPayloadConfigurazioneApprovvigionamento }>()
);

export const RETRIVE_LISTA_FRAZIONARIO = createAction(
  '[UTILITY] - retrive approvvigionamento ordini',
  props<{ payload: any }>()
);

export const RETRIVE_LISTA_FRAZIONARIO_SUCCESS = createAction(
  '[UTILITY] - retrive approvvigionamento ordini success',
  props<{ responseListFrazionario: IResponseOrdiniApprovvigionamento | null }>()
);
export const RESET_UTILITY_STORE = createAction(
  '[UTILITY] - reset recapito success',
);

export const RETRIEVE_PIN_RECOVERY = createAction(
  '[UTILITY] - retrieve pin recovery',
  props<{payload: IPinRecoveryPayload}>()
);

export const RETRIEVE_PIN_RECOVERY_SUCCESS = createAction(
  '[UTILITY] - retrieve pin recovery success',
  props<{responsePinRecovery: IResponsePinRecovery | null}>()
);
